import React from 'react';

const InsufficientTag = ({ insufficient }: { insufficient: boolean }) => {
  return insufficient ? (
    <div className='py-[3px] px-[10px] text-red-5 rounded-full bg-[#F4F1F1] font-medium text-xs'>
      Insufficient
    </div>
  ) : (
    <div className='w-[14px] h-[14px] rounded-full border-4 border-[#E60A2B]'></div>
  );
};

export default InsufficientTag;
